import Image from 'app/Components/Shared/Image/image';
import React from 'react';
import {Col, Container, Row} from 'reactstrap';
import EpiContext from '@episerver/spa-core/Spa';
import BtnWhite from '../../Shared/Buttons/BtnWhite';
import Config from '../../../Config';
import {Months, Years} from './data';
function BusinessCcrReportSuccessWithA(props) {
  let stringToDate;
  props.dates?.forEach((date, i) => {
    let indexDate = new Date(date.year, date.month - 1, 1);
    if (!stringToDate || indexDate.getTime() > stringToDate.getTime()) stringToDate = new Date(date.year, date.month - 1, 1);
  });

  return (
    <Container fluid>
      <Image src={require('./success.svg')} />
      <div className='client-information-change-hetPay-text'>
        <Row className='justify-content-center d-flex flex-column'>
          <span className='popup-title-bold'>
            לא ניתן להפיק דוח לחודש – {Months[stringToDate.getMonth()].value + '.' + stringToDate.getFullYear()}
          </span>
          <span className='popup-title'>מאחר והחשבונית עדיין לא נסגרה</span>
          <span className='popup-title'>יש לנסות שוב בעוד מספר ימים.</span>
        </Row>
        <Row className='justify-content-center d-flex flex-column mt-3 mb-3'>
          <span className='popup-title'> עבור החודשים האחרים </span>
          <span className='popup-title'> המידע ישלח למייל {props.mail} ב 24 שעות הקרובות. </span>
        </Row>
      </div>

      <Row className='justify-content-center mt-2'>
        <BtnWhite
          isBusiness
          text={`חזרה לאיזור האישי`}
          onclick={() => {
            props.setIsShowPopup(false);
            EpiContext.navigateTo(Config.businessLobbyUrl);
          }}
        />
      </Row>
    </Container>
  );
}

export default BusinessCcrReportSuccessWithA;
